export enum COMMERCE_CATEGORY {
  FREE = "commerce_free_media",
  MEMBER = "commerce_members_media",
  PPV = "commerce_ppv_media",
  SUBSCRIPTION = "commerce_subscription_basic_media",
  PPV_SUBSCRIPTION = "commerce_ppv_media|commerce_subscription_basic_media",
}
